<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    //在页面加载时读取localStorage里的状态信息
    if (sessionStorage.getItem("state")) {
      Object.assign(this.$store.state, JSON.parse(sessionStorage.getItem("state")));
      //使用后清除内存
      setTimeout(function () {
        sessionStorage.removeItem("state");
      }, 300);
    }

    //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("state", JSON.stringify(this.$store.state));
    });
  },
};
</script>

<style lang="scss">
@import "~@/assets/css/content.scss";
@import "~@/assets/css/u-style.scss";
@import "~@/assets/css/u-style-rem.scss";
@import "~@/assets/css/reset-elment.scss";
html,
body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0px;
  margin: 0px;
}
html {
  font-size: 4.882vw;
}
body {
  font-size: 0.18rem;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
.db-border-inline {
  border: solid 2px #016ae0;
  box-sizing: border-box;
  border-radius: 4px;
  overflow: hidden;
}
.db-border {
  padding: 1px;
  margin: 4px;
  margin-bottom: 10px;
  border-radius: 6px;
  outline: solid 2px #016ae0;
  border: solid 2px transparent;
}
.u-color-video-list {
  background-color: #016ae0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue